import { Link, useLocation, useNavigate } from "react-router-dom";
import { Compass, MessageCircle, UserRound, LogOut, Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Footer from "./Footer";

const links = [
  { to: "/discover", label: "Discover", icon: Compass, testid: "nav-discover-link" },
  { to: "/matches", label: "Matches", icon: MessageCircle, testid: "nav-matches-link" },
  { to: "/premium", label: "Premium", icon: Crown, testid: "nav-premium-link" },
  { to: "/profile", label: "Profile", icon: UserRound, testid: "nav-profile-link" },
];

export default function AppShell({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const linkClass = (to) => {
    if (location.pathname.startsWith(to)) return "text-[#7A3B3F]";
    if (to === "/premium" && user?.is_premium) return "text-[#C19A6B]";
    return "text-[#5C5C5C] hover:text-[#1A1A1A]";
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#1A1A1A]">
      <header className="fixed top-0 inset-x-0 z-50 bg-white/70 backdrop-blur-xl border-b border-white/40">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 h-16 flex items-center justify-between">
          <Link to="/discover" className="font-serif text-2xl tracking-tight" data-testid="shell-brand-link">
            Evervow
          </Link>
          <nav className="flex items-center gap-2 sm:gap-6">
            {links.map(({ to, label, icon: Icon, testid }) => (
              <Link
                key={to}
                to={to}
                data-testid={testid}
                className={`flex items-center gap-2 px-3 py-2 text-sm transition-colors duration-300 ${linkClass(to)}`}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
                <span className="hidden sm:inline">{label}</span>
              </Link>
            ))}
            <button
              data-testid="nav-logout-button"
              onClick={async () => {
                await logout();
                navigate("/");
              }}
              className="flex items-center gap-2 px-3 py-2 text-sm text-[#5C5C5C] hover:text-[#9A3B3B] transition-colors duration-300"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.5} />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </nav>
        </div>
      </header>
      <main className="pt-16">{children}</main>
      <Footer />
    </div>
  );
}
